/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Comparison_Product_Hunt_CtaInputs */

const en_directory_comparison_product_hunt_cta = /** @type {(inputs: Directory_Comparison_Product_Hunt_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See how listing works`)
};

const zh_directory_comparison_product_hunt_cta = /** @type {(inputs: Directory_Comparison_Product_Hunt_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`了解产品收录方式`)
};

/**
* | output |
* | --- |
* | "See how listing works" |
*
* @param {Directory_Comparison_Product_Hunt_CtaInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_comparison_product_hunt_cta = /** @type {((inputs?: Directory_Comparison_Product_Hunt_CtaInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Comparison_Product_Hunt_CtaInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_comparison_product_hunt_cta(inputs)
	return zh_directory_comparison_product_hunt_cta(inputs)
});
export { directory_comparison_product_hunt_cta as "directory.comparison.product_hunt.cta" }